import { PortalProvider } from '@gorhom/portal';

/**
 * This is required to make the `AbsoluteHost` and `Absolute` component work and should be placed at
 * the top level of the `App`
 */
export const AbsoluteProvider = PortalProvider;
